import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechAppointmentList,
    FIND_PIANOTECHAPPOINTMENT_STARTED,
    FIND_PIANOTECHAPPOINTMENT_SUCCEEDED,
    findPianoTechAppointment,
} from '../../actions/PianoTechAppointmentActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechAppointment,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechAppointment: state.pianoTechAppointment,
    user: state.user,
});

class PianoTechAppointmentTable extends React.PureComponent {
    componentDidMount() {
        //Retrieve list if they are not in state
        if (!this.props.pianoTechAppointment.pianoTechAppointmentList || this.props.pianoTechAppointment.pianoTechAppointmentList.length === 0)
            this.props.dispatch(fetchPianoTechAppointmentList());
    }

    refreshList = () => {
        this.props.dispatch(fetchPianoTechAppointmentList());
    }

    addPianoTechAppointment = () => {
        const originalPianoTechAppointment = Object.assign({}, defaultPianoTechAppointment);
        const pianoTechAppointment = Object.assign({}, defaultPianoTechAppointment);

        this.props.dispatch({
            type: FIND_PIANOTECHAPPOINTMENT_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechAppointment",
        });

        this.props.dispatch({
            type: FIND_PIANOTECHAPPOINTMENT_SUCCEEDED,
            pianoTechAppointment,
            originalPianoTechAppointment,
        });

    }

    viewPianoTechAppointment(appointmentId) {
        this.props.dispatch({
            type: FIND_PIANOTECHAPPOINTMENT_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View PianoTechAppointment",
        });

        this.props.dispatch(findPianoTechAppointment(appointmentId));
    }

    render() {
        const columns = [
            {
                name: 'Appointment Id',
                selector: row => row.appointmentId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Company Id',
                selector: row => row.companyId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Customer Id',
                selector: row => row.customerId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Technicians Id',
                selector: row => row.techniciansId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Piano Id',
                selector: row => row.pianoId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Tuning',
                selector: row => row.tuning,
                sortable: true,
                width: '10%',
            },
            {
                name: 'ServiceReason',
                selector: row => row.serviceReason,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Notes',
                selector: row => row.notes,
                sortable: true,
                width: '10%',
            },
            {
                name: 'NotificationTimestamp1',
                selector: row => row.notificationTimestamp1,
                sortable: true,
                width: '10%',
            },
            {
                name: 'NotificationTimestamp2',
                selector: row => row.notificationTimestamp2,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Buttons',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton"
                            onClick={() => { this.viewPianoTechAppointment(row.appointmentId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
            <div>
                <Message message={this.props.pianoTechAppointment.message} type={this.props.pianoTechAppointment.messageType} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td className='lefttext'>
                                <Button className="bluebutton" description="Refresh" onClick={this.refreshList} />
                            </td>
                            {this.props.user.allowAdd &&
                                <td className='righttext'>
                                    <Button className="bluebutton" description="Add PianoTechAppointment" onClick={this.addPianoTechAppointment} />
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
                <DataTable
                    title='PianoTechAppointment'
                    className='app-table'
                    columns={columns}
                    customStyles={customStyles}
                    striped
                    data={this.props.pianoTechAppointment.pianoTechAppointmentList}
                    defaultSortField="appointmentId"
                    highlightOnHover
                    pagination
                    onRowClicked={
                        (row) => { this.viewPianoTechAppointment(row.appointmentId) }
                    }
                />
            </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechAppointmentTable);
